import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-f15a0b76")

_pushScopeId("data-v-f15a0b76")
const _hoisted_1 = { class: "flex-grow whitespace-nowrap" }
const _hoisted_2 = { class: "w-full py-3 bg-white" }
const _hoisted_3 = {
  class: "flex flex-col overflow-y-auto",
  style: {"max-height":"450px"}
}
const _hoisted_4 = { class: "col-span-3 flex space-x-3 items-center" }
const _hoisted_5 = { class: "col-span-2 flex items-center" }
const _hoisted_6 = {
  key: 0,
  class: "flex space-x-2 items-center cursor-wait"
}
const _hoisted_7 = { class: "text-12px text-gray-lp-800" }
const _hoisted_8 = {
  key: 1,
  class: "flex space-x-2 items-center cursor-default"
}
const _hoisted_9 = { class: "text-12px text-gray-lp-800" }
const _hoisted_10 = { class: "text-xs" }
const _hoisted_11 = { class: "text-xs" }
const _hoisted_12 = {
  key: 3,
  class: "flex space-x-2 items-center cursor-default text-red-lp-100"
}
const _hoisted_13 = { class: "flex items-center justify-center bg-white rounded-full border border-red-lp-100 w-5 h-5" }
const _hoisted_14 = { class: "text-xs" }
const _hoisted_15 = {
  key: 0,
  class: "px-4"
}
const _hoisted_16 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { id: "infinite-scroll" }, null, -1)
const _hoisted_18 = { class: "px-6 flex flex-col space-y-2" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Icons = _resolveComponent("Icons")!
  const _component_skeleton = _resolveComponent("skeleton")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock("div", {
    class: ["fixed w-fit z-20 bottom-0 right-0 flex flex-col rounded-t-lg", { 'pb-4': _ctx.isShowRunningText }],
    style: {"box-shadow":"0px 0px 15px rgba(26, 20, 33, 0.15)","width":"360px"}
  }, [
    _createVNode("div", {
      class: "w-full px-6 py-3 text-white bg-red-lp-300 text-16px font-semibold space-x-6 flex items-center cursor-pointer rounded-t-lg",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onToggleMenu && _ctx.onToggleMenu(...args)))
    }, [
      _createVNode("span", _hoisted_1, _toDisplayString(_ctx.$t("cargo.widget.title")), 1),
      (_ctx.isCloseable)
        ? (_openBlock(), _createBlock(_component_Icons, {
            key: 0,
            name: "close",
            class: "w-4 text-white",
            onClick: _ctx.onClose
          }, null, 8, ["onClick"]))
        : _createCommentVNode("", true),
      _createVNode("img", {
        alt: "chevron",
        class: "w-5",
        src: 
          require(`@/app/ui/assets/svg/chevron-${
            _ctx.isOpen ? 'down' : 'up'
          }-white.svg`)
        
      }, null, 8, ["src"])
    ]),
    _withDirectives(_createVNode("div", _hoisted_2, [
      _withDirectives(_createVNode("div", _hoisted_3, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.downloadRequestList, (group, index) => {
          return (_openBlock(), _createBlock(_Fragment, {
            key: `${index}`
          }, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(group, (item, itemIndex) => {
              return (_openBlock(), _createBlock(_Fragment, {
                key: `${itemIndex}`
              }, [
                _withDirectives(_createVNode("div", { class: "pl-4 text-black-lp-300 font-semibold bg-gray-lp-200 text-12px" }, _toDisplayString(item.dateString), 513), [
                  [_vShow, itemIndex === 0]
                ]),
                _createVNode("div", {
                  class: ["px-4 grid grid-cols-5 space-x-2 items-center w-full item-hovered", itemIndex === group.length - 1 ? 'pt-4 pb-6' : 'py-4']
                }, [
                  _createVNode("div", _hoisted_4, [
                    _withDirectives(_createVNode("div", {
                      class: ["flex-grow min-w-0 truncate text-black-lp-300 text-14px", 
                    `${
                      item.title.length > 20
                        ? 'cursor-pointer'
                        : 'cursor-default'
                    }`
                  ],
                      style: 
                    item.status === 'failed'
                      ? 'text-decoration: line-through;'
                      : ''
                  
                    }, [
                      _createTextVNode(_toDisplayString(item.title), 1)
                    ], 6), [
                      [
                        _directive_tooltip,
                        
                    `${item.title.length > 20 ? item.title : ''}`
                  ,
                        void 0,
                        { bottom: true }
                      ]
                    ])
                  ]),
                  _createVNode("div", _hoisted_5, [
                    (item.status === 'waiting')
                      ? (_openBlock(), _createBlock("div", _hoisted_6, [
                          _createVNode(_component_Icons, {
                            name: "refresh",
                            class: "w-5 text-gray-lp-800"
                          }),
                          _createVNode("span", _hoisted_7, " Generate." + _toDisplayString(_ctx.extension(item.type)), 1)
                        ]))
                      : (item.url === 'no-data')
                        ? (_openBlock(), _createBlock("div", _hoisted_8, [
                            _createVNode("img", {
                              alt: "failed",
                              class: "w-5",
                              src: 
                      require(`@/app/ui/assets/svg/x-circle-outline-gray.svg`)
                    
                            }, null, 8, ["src"]),
                            _createVNode("span", _hoisted_9, _toDisplayString(_ctx.$t("cargo.widget.noDataFound")), 1)
                          ]))
                        : (item.status === 'success' && item.url)
                          ? (_openBlock(), _createBlock("div", {
                              key: 2,
                              class: "flex space-x-2 items-center cursor-pointer text-green-lp-100",
                              onClick: ($event: any) => (_ctx.onDownload(item))
                            }, [
                              (item.type === 'cargo-flight-awb-receipt')
                                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                                    _createVNode(_component_Icons, {
                                      name: "printer-v2",
                                      class: "w-5"
                                    }),
                                    _createVNode("span", _hoisted_10, _toDisplayString(_ctx.$t("cargo.widget.printPdf")), 1)
                                  ], 64))
                                : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                                    _createVNode(_component_Icons, {
                                      name: "download-new",
                                      class: "w-5"
                                    }),
                                    _createVNode("span", _hoisted_11, _toDisplayString(_ctx.$t("cargo.widget.download")), 1)
                                  ], 64))
                            ], 8, ["onClick"]))
                          : (_openBlock(), _createBlock("div", _hoisted_12, [
                              _createVNode("div", _hoisted_13, [
                                _createVNode(_component_Icons, {
                                  name: "close",
                                  class: "w-3"
                                })
                              ]),
                              _createVNode("span", _hoisted_14, _toDisplayString(_ctx.$t("cargo.widget.failed")), 1)
                            ]))
                  ])
                ], 2),
                (itemIndex < group.length - 1)
                  ? (_openBlock(), _createBlock("div", _hoisted_15, [
                      _hoisted_16
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128))
          ], 64))
        }), 128)),
        _hoisted_17,
        _withDirectives(_createVNode("div", _hoisted_18, [
          _createVNode(_component_skeleton, {
            width: "100%",
            height: "20px"
          }),
          _createVNode(_component_skeleton, {
            width: "90%",
            height: "20px"
          })
        ], 512), [
          [_vShow, _ctx.isLoading]
        ])
      ], 512), [
        [_vShow, _ctx.downloadRequestList.length]
      ])
    ], 512), [
      [_vShow, _ctx.isOpen]
    ])
  ], 2))
})